/* src/app/commonComponents/wide-modals/task-event-modal/task-datepicker/task-datepicker.component.scss */
.datepicker-container {
  min-height: 33px;
}
